const TOKEN_KEY = "token";

/** sessionStorage is per-tab; copy from localStorage so new tabs see the same login. */
export function hydrateSessionTokenFromLocalStorage(): void {
  try {
    if (!sessionStorage.getItem(TOKEN_KEY)) {
      const fromLocal = localStorage.getItem(TOKEN_KEY);
      if (fromLocal) {
        sessionStorage.setItem(TOKEN_KEY, fromLocal);
      }
    }
  } catch {
    // ignore private mode / quota errors
  }
}

export function clearAuthTokens(): void {
  try {
    sessionStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(TOKEN_KEY);
  } catch {
    // ignore
  }
}

/** Other tabs receive this when localStorage token changes (login / logout). */
export function subscribeAuthTokenStorage(
  onChange: (token: string | null) => void
): () => void {
  const handler = (e: StorageEvent) => {
    if (e.key !== TOKEN_KEY) return;
    onChange(e.newValue);
  };
  window.addEventListener("storage", handler);
  return () => window.removeEventListener("storage", handler);
}
